<template>
  <section class="my-20 border-t border-slate-200">
    <Container>
      <SectionHeader>Documents</SectionHeader>
      <div class="flex flex-wrap gap-10">
        <a
          v-for="doc in getDocuments"
          :key="doc.url"
          :href="doc.url"
          target="_blank"
          class="flex gap-3 items-center hover:underline!"
        >
          <span 
            class="text-white font-semibold px-2 py-1"
            :class="{
              'bg-[#34281A]': !getPrimaryColor,
              [`bg-[${getPrimaryColor}]`]: getPrimaryColor
            }"
          >
            PDF
          </span>
          <span class="font-medium">{{ doc.name }}</span>
        </a>
      </div>
    </Container>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';

  import SectionHeader from '../../components/SectionHeader';
  import Container from '../../components/Container';

  export default {
    name: 'Documents',
    components: {
      SectionHeader,
      Container
    },
    computed: {
      ...mapGetters('tour', ['getDocuments', 'getPrimaryColor'])
    }
  };
</script>
